import RestClient from './RestClient';
import { ReplyTemplate } from '../models';

class ReplyTemplates extends RestClient {
    constructor() {
        super({
            model: ReplyTemplate,
            entryPoint: 'reply-templates',
            id_field: '_id',
            resource: 'reply_template',
            resources: 'reply_templates',
            sortBy: 'name',
        });
    }
}

const ReplyTemplatesApi = new ReplyTemplates();
export default ReplyTemplatesApi;
